module.exports = __webpack_public_path__ + "assets/502b0acb3a210157ebfe5762c8a18e9c.png";